import React, { Component } from "react"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import styled from "styled-components"
import WidgetContainer from "./WidgetContainer"
import { media } from "../utils/style-utils"
import printLogo from "../images/logo/talent-toolbox-transparent.png"

const PageTitleContainer = styled.div`
  padding-top: 0 !important;
  padding-bottom: 10px !important;
`
const PageTitle = styled.h3`
  color: ${prop => prop.theme.primaryColor};
  margin-top: 0 !important;
  ${media.phone`font-size: 14px;`};
`

const FilterButton = styled.button`
  display: none;
  ${media.tablet`display: block;`};
  background-color: #fff;
  border: solid 1px #ccc;
  border-radius: 50px;
  width: 30px;
  height: 30px;
  line-height: 30px;

  &:hover {
    cursor: pointer;
    background-color: #f0f0f0;
  }

  &:focus {
    outline: 0;
  }
`

/* eslint-disable react/prefer-stateless-function */
class DashboardContents extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    onReload: PropTypes.func.isRequired,
    errorMessageKey: PropTypes.string,
    toggleFullScreenFilters: PropTypes.func.isRequired,
  }

  static defaultProps = {
    errorMessageKey: null,
  }

  render() {
    const {
      t,
      title,
      children,
      toggleFullScreenFilters,
      errorMessageKey,
      onReload,
    } = this.props

    return (
      <div className="container-fluid dashboard-contents">
        <PageTitleContainer className="row page-titles">
          <div className="col-10">
            <PageTitle>{title}</PageTitle>
          </div>
          <div className="d-none d-print-block col-2 text-right">
            <img src={printLogo} alt="Talent Toolbox" />
          </div>
          <div className="col-2 d-print-none">
            <FilterButton
              onClick={toggleFullScreenFilters}
              className="pull-right"
              title={t("Filters.SidebarToggleButton.Show")}
            >
              <i className="mdi mdi-filter" />
            </FilterButton>
            <div className="clearfix" />
          </div>
        </PageTitleContainer>
        <WidgetContainer errorMessageKey={errorMessageKey} onReload={onReload}>
          {children}
        </WidgetContainer>
      </div>
    )
  }
}

export default translate()(DashboardContents)



// WEBPACK FOOTER //
// ./src/components/DashboardContents.jsx